import { Z_INDEX_LAYER_TOP_FRONT } from "@/main/common/ZIndexLayers";

const PROGRESS_ELEMENT_ID = "seavien-navigation-progress";
const ACTIVE_CLASS_NAME = "is-active";

let progressHideTimeoutId: number | null = null;

function getProgressElement(): HTMLDivElement {
    let element = document.getElementById(PROGRESS_ELEMENT_ID) as HTMLDivElement | null;
    if (element) {
        return element;
    }

    element = document.createElement("div");
    element.id = PROGRESS_ELEMENT_ID;
    element.setAttribute("aria-hidden", "true");
    element.style.position = "fixed";
    element.style.top = "0";
    element.style.left = "0";
    element.style.height = "3px";
    element.style.width = "0%";
    element.style.opacity = "0";
    element.style.pointerEvents = "none";
    element.style.zIndex = String(Z_INDEX_LAYER_TOP_FRONT);
    element.style.background = "linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%)";
    element.style.boxShadow = "0 0 10px rgba(59, 130, 246, 0.45)";
    element.style.transition = "width 180ms ease, opacity 180ms ease";
    document.body.appendChild(element);
    return element;
}

function clearHideTimeout(): void {
    if (progressHideTimeoutId != null) {
        window.clearTimeout(progressHideTimeoutId);
        progressHideTimeoutId = null;
    }
}

export function startNavigationProgress(): void {
    if (typeof document === "undefined") {
        return;
    }

    clearHideTimeout();
    const element = getProgressElement();
    element.classList.add(ACTIVE_CLASS_NAME);
    element.style.opacity = "1";
    element.style.width = "18%";

    window.setTimeout(() => {
        if (!element.classList.contains(ACTIVE_CLASS_NAME)) {
            return;
        }

        element.style.width = "72%";
    }, 80);
}

export function completeNavigationProgress(): void {
    if (typeof document === "undefined") {
        return;
    }

    clearHideTimeout();
    const element = getProgressElement();
    element.style.opacity = "1";
    element.style.width = "100%";
    progressHideTimeoutId = window.setTimeout(() => {
        element.classList.remove(ACTIVE_CLASS_NAME);
        element.style.opacity = "0";
        element.style.width = "0%";
        progressHideTimeoutId = null;
    }, 220);
}

export function failNavigationProgress(): void {
    if (typeof document === "undefined") {
        return;
    }

    clearHideTimeout();
    const element = getProgressElement();
    element.classList.remove(ACTIVE_CLASS_NAME);
    element.style.opacity = "0";
    element.style.width = "0%";
}
